import { useState, useEffect, useCallback } from "react";
import {
  HeaderComponent,
  BodyComponent,
  TableComponent,
  ActionComponent,
  CreateButton, RefreshButton,
  trans,
  FilterComponent,
  FilterButton,
  EmployeeWithProfile,
  PaginationComponent, ImportButton, DownloadButton, SelectWithSearch
} from "@comps/components";
import { makeRequest, makeRequestStateless, handleDownloadFile } from "@utils/helpers";
import { getAllCustomPayitemsReq, getCustomPayitemReq, getFilterReq } from "./requests";
import { Const } from "../constants";
import { Collapse, Tag, Space, Empty, Divider, Form, Spin, } from "antd";
import { getResourceDataReq, createSelectList } from "@comps/commonFunctions";
import _ from "lodash";
import { useSelector } from "react-redux";
import moment from "moment/moment";
import dayjs from 'dayjs';
import UpdateCustomPayitem from "@mods/payrollManagement/settings/customPayitems/components/UpdateCustomPayitem";
import CreateCustomPayitem from "@mods/payrollManagement/settings/customPayitems/components/CreateCustomPayitem";
import IndexCompanyTimeSheet from "../../attendanceManagement/companyTimeSheet/IndexCompanyTimeSheet";
import IndexCompanyLeaveRequests from "../../leaveManagement/leave/companyLeaves/IndexCompanyLeaveRequests";
// ==================================
//   Page Breadcrumbs Start
// ==================================

const langKey = Const["salary"].lngKey

const pageConfig = {
  headers: {
    title: "Employee Quick Info Form",
    breadcrumb: [
      {
        name: "Employee Quick Info Form",
        //path: Const["salary"].route,
      },
    ],
  },
};

// ==================================
//   Page Breadcrumbs End
// ==================================

const IndexQuickEmployeeInfo = (props) => {
  const totalRecords = 0;
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);
  const [filters, setFilters] = useState(props.filters);
  const [allCustomPayitems, setAllCustomPayitems] = useState([]);
  const [collapsePayitems, setCollapsePayitems] = useState([])
  const [searchFrom] = Form.useForm();
  const authUser = useSelector((state) => state.auth.authUser);
  const [empployments, setEmployments] = useState([]);
  const [employeesAll, setAllEmployees] = useState([]);
  const [employmentId, setEmploymentId] = useState(null);
  const [timesheetComponent, setTimesheetComponent] = useState(null);
  const [leaveSummaryComponent, setLeaveSummaryComponent] = useState(null);

  useEffect(() => {
    // getAllCustomPayitems();
    // eslint-disable-next-line
  }, [filters]);


  //filter
  const onApplyFilter = (fils) => {
    setFilters(fils)
  }
  const onOpenFilter = () => {
    setChildComponent(<FilterComponent filters={ filterFields } modkey={ props.modkey } selected={ filters } api={ getFilterReq } onFilter={ onApplyFilter } onCloseFilter={ onCloseFilter }
    />
    )
  }
  const onCloseFilter = () => {
    setChildComponent(null);
  }


  //employee search field
  const debouncedGetEmployees = useCallback(
    _.debounce((value) => {
      getEmployees(`search_|${value}`);
    }, 500),
    [] // Empty array ensures the function is created only once
  );
  const onSearchEmployee = (value) => {
    debouncedGetEmployees(value)
    //getEmployees(`search_|${value}`)
  }
  const onFocusEmployeeSearch = () => {
    if (empployments.length === 0) {
      getEmployees()
    }
  }
  const getEmployees = (filters) => {
    if (authUser.role_id === 1 || authUser.role_id === 4) {

    } else {
      filters = `${filters};subordinate_|${authUser.employment_id}`;
    }
    let payload = {
      page: 1,
      type: 'employment',
      filters: filters
    }
    makeRequest(setLoader, getResourceDataReq, payload, onSuccessEmployee, onErrorEmployee);
  }

  const onSuccessEmployee = (response) => {
    setAllEmployees(response.resources.data)
    setEmployments(createSelectList(response.resources.data));
    setLoader(false)
  }
  const onErrorEmployee = (response) => {
    setLoader(false)
  }



  const columns = [

    {
      key: 'date',
      title: "Date",
      render: (record) => (
        dayjs(record.date).format('YYYY-MM-DD')
      )
    },
    {
      key: 'amount',
      title: "Amount",
      render: (record) => (
        'Rs ' + record.amount
      )
    },
    {
      key: 'processed',
      title: "Processed",
      render: (record) => (
        record.processed ? "Yes" : "No"
      ),
    },
    {
      key: "Actions",
      title: "Actions",
      render: (record) => (
        <ActionComponent
          each={ record } modkey={ props.modkey }
          //onDelete={ !record.processed && onDelete }
          onEdit={ onEditCustomPayitem }
          onView={ onViewCustomPayitem }
        ></ActionComponent>
      ),
    },
  ];

  const onEditCustomPayitem = (record) => {

    setChildComponent(
      <UpdateCustomPayitem onCompleted={ onCompleted } record={ record } disabled={ false } allData={ {} } />
    );
  };

  const onViewCustomPayitem = (record) => {
    setChildComponent(
      <UpdateCustomPayitem onCompleted={ onCompleted } record={ record } disabled={ true } allData={ {} } />
    );
  };

  // Create component modal
  const onCreateCustomPayitem = (payitemId) => {

    setChildComponent(<CreateCustomPayitem onCompleted={ onCompleted } onSuccess={ onCompleted } payitemId={ payitemId } employment_id={ employmentId } />);
  };

  const onCompleted = (data) => {
    // if (data.length) {
    //   setDataSource(data);
    // }
    if (data) {
      getAllCustomPayitems(employmentId);
    }

    setChildComponent(null);
  };
  const onViewEmployee = (id, isAuth) => {
    setEmploymentId(id)
    setTimesheetComponent(null)
    if (id) {
      setTimesheetComponent(<IndexCompanyTimeSheet module="my-attendance" filters={ `employee_|${id}` } modkey="quickEmployeeInfo" employmentId={ id } />)
      setLeaveSummaryComponent(<IndexCompanyLeaveRequests modkey="quickEmployeeInfo" filters={ `employee_|${id}` } employmentId={ id } />)
    } else {
      setTimesheetComponent(null)
      setLeaveSummaryComponent(null)
    }
    getAllCustomPayitems(id)
  };

  const getAllCustomPayitems = (employment_id) => {
    let date = moment().format("YYYY-MM-DD");
    // date = "2022-11-26"
    const payload = {
      page: 1,
      filters: filters,
      employment_id: employment_id,
      date: date
    }
    makeRequest(setLoader, getAllCustomPayitemsReq, payload, onGetAllCustomPayitems, null);
  };


  const onGetAllCustomPayitems = (response) => {
    setCollapsePayitems([]);
    setAllCustomPayitems(response.payitems);
    let tempPayitems = [];
    response.payitems.forEach(each => {
      tempPayitems.push({
        key: each.id,
        label: (
          <div className="flex items-center justify-between p-2">
            <Space>
              <span className="font-medium text-gray-700">{ each.name }</span>
              <Tag color={ each.type_name === "Deduction" ? 'red' : 'blue' }>{ each.type_name }</Tag>
            </Space>
          </div>
        ),
        children: (
          <>
            {
              each.custom_payitems.length > 0 ?
                <>
                  <HeaderComponent modkey={ props.modkey }>
                    <CreateButton onClick={ () => onCreateCustomPayitem(each.id) } />
                  </HeaderComponent>
                  <TableComponent modkey={ props.modkey }
                    loader={ loader }
                    columns={ columns }
                    dataSource={ each.custom_payitems }
                  // pagination={ { ...pagination, total: totalRecords } }
                  // onChange={ handleTableChange }
                  />
                </> :
                <>
                  <HeaderComponent modkey={ props.modkey }>
                    <CreateButton onClick={ () => onCreateCustomPayitem(each.id) } />
                  </HeaderComponent>
                  <Empty />
                </>
            }
          </>
        ),
        showArrow: true,

      });
    });
    setCollapsePayitems(tempPayitems);
    // setAllData(response)
    // setPagination(response.custom_payitems);
    // setDataSource(response.custom_payitems.data);

  };

  const onChangeCustomPayitemPanel = (payitem_id) => {

    //getCustomPayitemData(payitem_id)
  };
  const getCustomPayitemData = (payitem_id) => {
    let date = moment().format("YYYY-MM-DD");
    date = "2022-11-26"
    const payload = {
      id: payitem_id,
      page: 1,
      filters: `employees_|${employmentId};date_|${date};`
    }
    makeRequest(setLoader, getCustomPayitemReq, payload, onGetCustomPayitemData, null);
  };

  const onGetCustomPayitemData = (response) => {

    // setAllData(response)
    // setPagination(response.custom_payitems);
    // setDataSource(response.custom_payitems.data);

  };
  //----end filter--------------------
  return (
    <>
      { childComponent }
      <HeaderComponent headers={ pageConfig.headers } modkey={ props.modkey }>

        { props.filters === undefined && <><RefreshButton onClick={ () => getAllCustomPayitems(employmentId) } />
        </> }

      </HeaderComponent>
      <BodyComponent>
        <div >
          <Form form={ searchFrom } name="searchFrom" className="mt-3">
            <Spin spinning={ loader }>
              <Form.Item name={ 'employment_id' } label="Employee">
                <SelectWithSearch options={ empployments } onSearch={ onSearchEmployee } style={ { minWidth: 100, borderRadius: 5, background: '#FFFFFF', height: 41 } } searchEmployeeHeader={ true } setallemployees={ setAllEmployees } onChange={ onViewEmployee } type="employment" placeholder="Search Employee" onFocus={ () => onFocusEmployeeSearch('') } />

              </Form.Item>
            </Spin>
          </Form>

        </div>
        <hr />
        <div>
          <h5 className="text-primary"><strong>Custom Payitems Entry</strong></h5>
        </div>

        <div className="mb-5">
          <Collapse
            size="large"
            items={ collapsePayitems }
            defaultActiveKey={ collapsePayitems.map(item => item.id) } // keep all open
            onChange={ onChangeCustomPayitemPanel }
            accordion
            bordered={ true }
            className="m-2 shadow-sm rounded-lg bg-white"

          />
        </div>
        <hr />
        <div className="mb-5">
          <h5 className="text-primary"><strong>Attendance Sheet</strong></h5>
        </div>

        {
          timesheetComponent
        }

        <hr />
        <div className="mb-5">
          <h5 className="text-primary"><strong>Leave Summary</strong></h5>
          {
            leaveSummaryComponent
          }
        </div>
        <hr />
      </BodyComponent>

    </>
  );
};

export default IndexQuickEmployeeInfo;
const filterFields = [

  // {
  //   type: "select",
  //   placeholder: 'Employee',
  //   key: "employee",
  //   data_key: "supporting_data.employments",
  //   resource_type: 'employment',
  //   multiple: false
  // },

  // {
  //   type: "select",
  //   placeholder: trans(`${langKey}.department_name`),
  //   key: "department",
  //   data_key: "organization_structure_data.department",
  //   //is_resource: true
  // },
  // {
  //   type: "date",
  //   placeholder: "From",
  //   key: "from"
  // },
  // {
  //   type: "date",
  //   placeholder: "To",
  //   key: "to"
  // },



]